import React from 'react';

export const CHART_PALETTE = [
  '#a78bfa', // violet-400
  '#34d399', // emerald-400
  '#fbbf24', // amber-400
  '#38bdf8', // sky-400
  '#f472b6', // pink-400
  '#fb7185', // rose-400
];

export const TOOLTIP_STYLE = {
  backgroundColor: '#0f0f1a',
  border: '1px solid #312e5c',
  borderRadius: 8,
  fontSize: 12,
  padding: '8px 12px',
} as const;

export const TOOLTIP_LABEL_STYLE = { color: '#c4c4e0', fontWeight: 600, marginBottom: 4 } as const;
export const TOOLTIP_ITEM_STYLE = { color: '#e9e9f5' } as const;

export const tooltipFormatter = (v: unknown): string => {
  if (typeof v === 'number') return v.toLocaleString();
  if (v === null || v === undefined) return '—';
  return String(v);
};

export function EmptyChart({ message, height = 192 }: { message: string; height?: number }): React.ReactElement {
  return (
    <div className="flex items-center justify-center" style={{ height }}>
      <p className="text-xs text-gray-600 italic">{message}</p>
    </div>
  );
}
